import React, { useEffect, useState } from 'react';
import { getLandingPageVariant, logExperimentView } from '../firebase';

const ABTestWrapper = ({ children, variantA, variantB }) => {
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Get all current URL parameters
    const params = new URLSearchParams(window.location.search);
    const variantOverride = params.get('variant')?.toUpperCase();
    let selectedVariant;
    if (variantOverride === 'A' || variantOverride === 'B') {
      selectedVariant = variantOverride;
    } else {
      selectedVariant = getLandingPageVariant();
    }
    setSelectedVariant(selectedVariant);
    localStorage.setItem('landing_page_variant', selectedVariant);
    logExperimentView(selectedVariant);
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return null; // Or a loading spinner
  }

  return selectedVariant === 'A' ? variantA : variantB;
};

export default ABTestWrapper;